import React, { useEffect, useState } from 'react'
import { Select, Button, Spin, Tooltip, Space } from 'antd'
import { useNavigate } from 'react-router-dom'

import Layout from '../../../components/layout/Layout'
import axiosInstance from '../../../utils/axiosInstance'

const MultiSelectBlock = ({ label, placeholder, valueKey, form, focusItems, onChange }) => {
  return (
    <>
      <span>{label}</span>
      <Select
        mode="multiple"
        optionFilterProp="label"
        placeholder={placeholder}
        style={{ width: '100%' }}
        onChange={(value) => onChange({ [valueKey]: value })}
        defaultValue={focusItems
          ?.filter((item) => form[valueKey]?.includes(item._id))
          .map((item) => ({
            label: item.subTitle,
            value: item._id,
          }))}
        options={focusItems.map((item) => ({
          label: `(${item.points}pts - ${item.category.charAt(0).toUpperCase() + item.category.slice(1)}) ${item.subTitle}`,
          value: item._id,
        }))}
      />
    </>
  )
}

function LeadershipTrackActivities() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)
  const [focusItems, setFocusItems] = useState([])
  const [form, setForm] = useState({})
  const [leadershipTrackActivities, setLeadershipTrackActivities] = useState(null)

  const onChange = (obj) => {
    setForm((prev) => ({ ...prev, ...obj }))
  }

  const getMyInfo = async () => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/admin/me`)

      // Check the admin organizations
      if (response?.data?.user?.organizations && response?.data?.user?.organizations.length > 0) {
        const org = response.data.user.organizations
        // console.log(org)
      }

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  // All all focus items from all clubs
  const getFocusItems = async () => {
    try {
      setLoading(true)

      let query = `/api/v1/focus/focusItems`

      const response = await axiosInstance.get(query)
      setFocusItems(response.data?.focusItems)
      getLeadershipTrackActivities()
      // setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const getLeadershipTrackActivities = async () => {
    try {
      setLoading(true)

      let query = `/api/v1/metrics/getLeadershipTrackActivities`
      const response = await axiosInstance.get(query)

      if (response?.data?.data) {
        const { connection, support, guide, opportunityCreator, leaderDeveloper, cultureBuilder } = response.data.data
        setForm({
          connection,
          support,
          guide,
          opportunityCreator,
          leaderDeveloper,
          cultureBuilder,
        })

        setLeadershipTrackActivities(response.data.data)
      } else {
        setLeadershipTrackActivities({})
      }

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const handleSave = async () => {
    try {
      setLoading(true)

      console.log(form)

      let query = `/api/v1/metrics/leadershipTrackActivities`
      const response = await axiosInstance.post(query, { form })

      console.log(response.data)

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    getFocusItems()
  }, [])

  // TODO: Remove soon
  useEffect(() => {
    console.log(form)
  }, [form])

  return (
    <Layout>
      <Button type="default" onClick={() => navigate(-1)} style={{ marginBottom: 0 }}>
        Back
      </Button>

      <h2>Modify Leadership Track activities</h2>

      <p style={{ color: '#db9494' }}>Atleast 1 item is required at all fields to generate results.</p>

      {loading && <Spin />}

      <div style={{ marginTop: 10 }}></div>

      {leadershipTrackActivities && (
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
          {/* before making it reuseable, keeping this one only as reference, all of them created below via MultiSelectBlock reuseable component */}
          {/* <span>Supports</span>
          <Select
            mode="multiple"
            optionFilterProp="label"
            placeholder="Support activities"
            style={{
              width: `100%`,
            }}
            onChange={(value) => onChange({ support: value })}
            defaultValue={focusItems
              ?.filter((elTwo) =>
                form.support?.some((itemId) => {
                  return itemId === elTwo._id
                })
              ) // ! test this
              .map((el) => {
                return {
                  label: el.subTitle,
                  value: el._id,
                }
              })}
            options={focusItems
              // .filter((el) => el.category == 'habits') // Keep for reference if needed
              .map((el) => {
                return {
                  label: `(${el.points}pts - ${el.category.charAt(0).toUpperCase() + el.category.slice(1)}) ${el.subTitle} `,
                  value: el._id,
                }
              })}
          /> */}

          <MultiSelectBlock label="Supports" placeholder="Support activities" valueKey="support" form={form} focusItems={focusItems} onChange={onChange} />

          <MultiSelectBlock label="Connection" placeholder="Connection activities" valueKey="connection" form={form} focusItems={focusItems} onChange={onChange} />

          <MultiSelectBlock label="Guide" placeholder="Guide activities" valueKey="guide" form={form} focusItems={focusItems} onChange={onChange} />

          <MultiSelectBlock
            label="Opportunity Creator"
            placeholder="Opportunity Creator activities"
            valueKey="opportunityCreator"
            form={form}
            focusItems={focusItems}
            onChange={onChange}
          />

          <MultiSelectBlock label="Leader Developer" placeholder="Leader Developer activities" valueKey="leaderDeveloper" form={form} focusItems={focusItems} onChange={onChange} />

          <MultiSelectBlock label="Culture Builder" placeholder="Culture Builder activities" valueKey="cultureBuilder" form={form} focusItems={focusItems} onChange={onChange} />

          <Button
            type="primary"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              handleSave()
            }}
            loading={loading}
          >
            Update
          </Button>
        </Space>
      )}
    </Layout>
  )
}

export default LeadershipTrackActivities
